const PixelStudioIcon = () => {
  const fill = "white";
  return (
    <svg
      //   width="504"
      //   height="553"
      // width="504"
      // height="553"
      viewBox="0 0 504 553"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M236.055 31.718V0L264.555 0.554993L265.107 32.334L341.831 31.857C384.029 31.595 419.118 31.569 419.805 31.801C420.728 32.111 421.055 35.996 421.055 46.638V61.055H366.055V178.055H351.162C338.504 178.055 336.178 177.818 335.662 176.473C335.328 175.603 335.055 149.278 335.055 117.973V61.055H80.002L80.555 31.957L236.055 31.718Z"
        fill={fill}
      />
      <path
        d="M2.67999 58.93C1.87499 54.903 1.86 8.58299 2.664 7.77899C2.999 7.44499 15.149 7.133 29.664 7.088L56.055 7.00499V35.055H29.055L28.863 42.805C28.757 47.067 28.728 51.68 28.798 53.055C28.867 54.43 28.709 57.017 28.444 58.805L27.964 62.055H3.30499L2.67999 58.93Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M447.055 35.055V7.133L501.555 7.55499L501.484 9.80499C501.444 11.043 501.332 30.505 501.234 53.055L501.055 94.055H478.055V261.055H503.055V289.055L492.305 289.207C486.392 289.291 480.88 289.404 480.055 289.459C478.734 289.546 478.525 301.639 478.3 390.806L478.045 492.055H501.055V540.055H447.055V522.055H265.055L265.044 533.305C265.038 539.493 264.754 546.243 264.413 548.305L263.793 552.055H236.055V522.055H56.055V540.055H3.33398L2.703 534.805C2.356 531.917 2.068 521.118 2.064 510.805L2.05499 492.055H27.065L26.555 289.555H0.554993L0 261.113L26.555 260.555L27.066 91.002L56.555 91.555L56.751 237.918C56.859 318.417 57.084 384.414 57.251 384.578C57.418 384.742 74.43 368.259 95.055 347.95C115.68 327.641 134.947 308.926 137.871 306.362L143.187 301.7L200.594 359.081L217.574 342.315C226.914 333.093 246.705 313.633 261.555 299.069C276.405 284.505 309.932 251.431 336.059 225.572C362.186 199.713 389.764 172.487 397.342 165.07L411.121 151.585L446.951 188.555L447.055 93.381L420.555 93.555L420.004 62.055H474.055V35.055H447.055ZM326.055 363.055V323.055H286.055V363.055H326.055ZM419.055 459.055V409.055H366.055V459.055H419.055ZM212.055 491.055V463.055H57.055V491.055H212.055ZM448 235H413V270H448V235Z"
        fill={fill}
      />
      <path
        d="M224.487 119.138C221.521 107.706 227.765 96.393 238.898 93.03C242.777 91.858 249.068 92.031 252.889 93.415C257.873 95.219 263.745 101.606 265.625 107.267C270.441 121.764 258.548 136.194 242.951 134.779C232.99 133.876 226.991 128.795 224.487 119.138Z"
        fill={fill}
      />
      <path
        d="M91.65 141.987C96.778 124.53 109.328 111.512 127.055 105.264C132.737 103.261 135.003 103.022 145.055 103.364C155.73 103.727 157.112 104.013 164.317 107.345C183.377 116.162 196.055 135.717 196.055 156.3C196.055 170.796 190.79 183.551 180.682 193.544C170.221 203.885 157.451 209.055 142.371 209.055C128.253 209.055 116.842 204.719 107.233 195.703C100.189 189.094 94.55 180.396 92.04 172.272C89.544 164.192 89.359 149.787 91.65 141.987Z"
        fill={fill}
      />
      <path
        d="M208.055 244.209C208.055 233.471 215.04 225.234 226.055 222.982C232.598 221.644 238.219 223.401 243.944 228.574C258.611 241.824 249.05 265.619 229.114 265.484C216.838 265.4 208.055 256.528 208.055 244.209Z"
        fill={fill}
      />
    </svg>
  );
};

export default PixelStudioIcon;
